import React from 'react';
import { ArrowPathIcon } from '@heroicons/react/24/outline';

interface RefreshButtonProps {
  onClick: () => void;
  fetching: boolean;
  disabled?: boolean;
}

// Icon-only refresh button. The icon spins while data loads.
export const RefreshButton: React.FC<RefreshButtonProps> = ({ onClick, fetching, disabled }) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    aria-label="Refresh"
    title="Refresh"
    className="ml-auto h-10 w-10 flex items-center justify-center rounded-md border border-gray-600 text-secondary hover:text-primary hover:border-primary transition-colors disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:text-secondary disabled:hover:border-gray-600"
  >
    <ArrowPathIcon className={`w-5 h-5 ${fetching ? 'animate-spin' : ''}`} />
  </button>
);

export default RefreshButton;
